/* Tonic Home V2: Splash colour picker. A swatch swaps the product photo, its link and the colour name. */
class ThSplash extends HTMLElement {
  connectedCallback() {
    this.stage = this.querySelector('.th-splash__stage');
    this.ripple = this.querySelector('.th-splash__ripple');
    this.name = this.querySelector('.th-splash__name');
    this.swatches = [...this.querySelectorAll('.th-splash__sw button')];
    this.images = this.stage ? [...this.stage.querySelectorAll('img')] : [];
    this.namePrefix = this.name ? this.name.textContent.replace(this.swatches[0] ? this.swatches[0].dataset.name : '', '') : '';
    this.swatches.forEach((sw, i) => {
      sw.addEventListener('click', () => this.select(i));
      sw.addEventListener('keydown', (event) => {
        const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[event.key];
        if (!step) return;
        event.preventDefault();
        const next = (i + step + this.swatches.length) % this.swatches.length;
        this.select(next);
        this.swatches[next].focus();
      });
      sw.tabIndex = i === 0 ? 0 : -1;
    });
    // The reel is decorative, so it stays still for people who ask for less motion.
    const video = this.querySelector('.th-splash__video video');
    if (video && matchMedia('(prefers-reduced-motion: reduce)').matches) video.pause();
  }

  select(index) {
    const sw = this.swatches[index];
    this.swatches.forEach((s, i) => {
      s.setAttribute('aria-checked', i === index);
      s.tabIndex = i === index ? 0 : -1;
    });
    this.images.forEach((img, i) => img.classList.toggle('is-on', i === index));
    if (sw.dataset.url) this.stage.href = sw.dataset.url;
    if (this.name) this.name.textContent = this.namePrefix + sw.dataset.name;
    this.stage.style.setProperty('--th-splash-pick', getComputedStyle(sw).getPropertyValue('--c'));
    this.ripple.classList.remove('go');
    void this.ripple.offsetWidth; // Restarts the ripple animation.
    this.ripple.classList.add('go');
  }
}

if (!customElements.get('th-splash')) customElements.define('th-splash', ThSplash);
